import React from 'react';
import { Link } from 'react-router-dom';
import scrollTo from '../helpers/scroll-to';
import images from '../assets/images';

const Footer = (props) => {
    return(
      <footer id="footer">
        <hr className="offset-md-3 col-md-6" />
        <div className="canais text-center mt-4">
          <h4>Nossos canais</h4>
          <a className="mr-2" href="https://www.facebook.com/paodeacucar" target="_blank">
            <img src={images.icons.icon_facebook} />
          </a>
          <a className="mr-2" href="https://www.instagram.com/paodeacucar/" target="_blank">
            <img src={images.icons.icon_instagram} />
          </a>
          <a className="mr-2" href="https://www.youtube.com/user/videosPaodeAcucar" target="_blank">
            <img src={images.icons.icon_youtube} />
          </a>
          <a className="mr-2" href="https://twitter.com/paodeacucar" target="_blank">
            <img src={images.icons.icon_twitter} />
          </a>
        </div>

        <div className="container menu-footer mt-5">
          <div className="row">
            <div className="col-md-4 col-xs-12">
              <i className="font-16 material-icons text-primary">phone</i>{' '}
              <strong>Atendimento</strong><br />
              São Paulo: <a href="tel:+551130556767" className="text-default">(11) 3055-6767</a><br />
              Demais Localidades: <a href="tel:+551140046070" className="text-default">(11) 4004-6070</a>
            </div>
            <div className="col-md-4 col-xs-12 text-center">
              <a className="footer-link1" href="https://www.paodeacucar.com/fale-conosco" target="_blank">
                <i className="font-16 material-icons">email</i>{' '}
                <strong>Fale-conosco</strong>
              </a>
            </div>
            <div className="col-md-4 col-xs-12 text-right">
              <a className="footer-link1" href="https://www.paodeacucar.com/duvidas-frequentes" target="_blank">
                <i className="font-16 material-icons">help</i>{' '}
                <strong>Dúvidas frequentes</strong>
              </a>
            </div>
          </div>
        </div>
      </footer>
    );
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/Footer.js